import { createTheme } from '@mui/material/styles';
import { CARD_RADIUS, CARD_SHADOW } from './theme/cardTokens';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#0466C8',
      dark: '#005B8C',
      light: '#90E0EF',
    },
    secondary: {
      main: '#00B4D8',
    },
    success: {
      main: '#22C55E',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#EF4444',
    },
    warning: {
      main: '#F59E0B',
    },
    info: {
      main: '#3B82F6',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E293B',
      secondary: '#64748B',
      disabled: '#94A3B8',
    },
    divider: '#E2E8F0',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2rem', fontWeight: 700, color: '#1E293B' },
    h2: { fontSize: '1.5rem', fontWeight: 700, color: '#1E293B' },
    h3: { fontSize: '1.25rem', fontWeight: 600, color: '#1E293B' },
    body1: { fontSize: '1rem', color: '#1E293B' },
    body2: { fontSize: '0.875rem', color: '#1E293B' },
    caption: { fontSize: '0.75rem', color: '#64748B' },
    button: { fontSize: '0.875rem', fontWeight: 600, textTransform: 'none' },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: CARD_RADIUS.md,
          boxShadow: CARD_SHADOW.sm,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 24px',
          textTransform: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          '&:hover': { backgroundColor: '#005B8C' },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled',
      },
      styleOverrides: {
        root: {
          '& .MuiFilledInput-root': {
            backgroundColor: '#F3F4F6',
            borderRadius: 8,
            '&:before, &:after': { display: 'none' },
            '&:hover': { backgroundColor: '#F3F4F6' },
            '&.Mui-focused': {
              backgroundColor: '#F3F4F6',
              outline: '1px solid #0466C8',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0466C8',
          color: '#FFFFFF',
          boxShadow: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFFFFF',
          boxShadow: 'none',
          borderRight: 'none',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          backgroundColor: '#0466C8',
          color: '#FFFFFF',
          '&:hover': { backgroundColor: '#005B8C' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 700,
          fontSize: '0.75rem',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#E2E8F0',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});
